export default function CustomHomeBuildersHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/133f380e2ae8a7d41d04cca66b72777a.jpg"
          alt="Custom Home Builders in El Paso"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Custom Home Builders in El Paso
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-white/95">
          Build your dream home with expert custom home builders. Find licensed, insured professionals specializing in luxury custom homes, energy-efficient designs, and personalized construction throughout El Paso.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#directory" className="px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Find Builders
          </a>
          <a href="#checklist" className="px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap">
            Builder Checklist
          </a>
        </div>
      </div>
    </section>
  );
}
